<template>
  <div>
    <canvas ref="canvasRef" style="height: 325px;width: 1000px;" width="1000" height="325"></canvas>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        rentRateNum: 46.05,
        totalRentNum: 35,
        totalEmptyNum: 41,
        ringsWidthNum: 50,

        rentRate: 0,
        totalRent: 0,
        totalEmpty: 0,
        ringsWidth: 50,

        ctx: null,
        lineWidth: 0,
        centerX: 0,
        centerY: 0,
        radius: 0,
        startAngle: 0,
        endAngle: 0,
        progress: 0
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      drawProgressBar() {
        this.ctx.beginPath()
    	  this.ctx.lineWidth = this.lineWidth
        this.ctx.strokeStyle = '#ff5454'
        this.ctx.arc(this.centerX, this.centerY, this.radius, this.startAngle, this.progress, true) // 逆时针得减，顺时针是startAngle + rentRate * 2 * Math.PI
        this.ctx.stroke()
      },
      animateProgress() {
        if (this.progress > this.endAngle) {
          this.progress -= 0.02 // 控制动画速度
          this.drawProgressBar()
          requestAnimationFrame(this.animateProgress)
        } else {
          this.drawProgressBar(100)
        }
      },
      init() {
        this.rentRate = Number(this.rentRateNum) * 100 / 10000
        this.totalRent = this.totalRentNum
        this.totalEmpty = this.totalEmptyNum
        this.ringsWidth = this.ringsWidthNum

        this.$nextTick(() => {
          this.drawCanvas()
        })
      },
      drawCanvas() {
      const canvas = this.$refs.canvasRef
			const ctx = canvas.getContext('2d')
			const dpr = window.devicePixelRatio
			const width = canvas.width
			const height = canvas.height

			canvas.width = width * dpr
			canvas.height = height * dpr
			ctx.scale(dpr, dpr)
			// canvas.width = width
			// canvas.height = height

			const centerX = width / 2
			const centerY = height / 2
			const ringWidth = this.ringsWidth / 2
			const radius = Math.min(width, height) / 2 / dpr - ringWidth / 2 / dpr // 半径为宽/高的一半再去乘dpr，加上圆环宽度
			const startAngle = Math.PI / 2

			console.log('---', width * dpr, height * dpr, radius)

			// 清空画布
			ctx.clearRect(0, 0, width, height)

			// 1/4 圆	Math.PI / 2	90°
			// 1/2 圆	Math.PI	180°
			// 3/4 圆	Math.PI * 1.5	270°
			// 1 圆（整圈）	Math.PI * 2	360°

			// 绘制空置绿色环
			ctx.beginPath()
			ctx.lineWidth = ringWidth
			ctx.strokeStyle = '#07d280'
			ctx.lineCap = 'round'
			ctx.arc(centerX, centerY, radius, startAngle, startAngle + Math.PI * 2, false) // 画满一整圈
			ctx.stroke()

			// 绘制出租红色环
			// ctx.beginPath()
			// ctx.strokeStyle = '#ff5454'
			// ctx.arc(centerX, centerY, radius, startAngle, startAngle - this.rentRate * 2 * Math.PI, true) // 逆时针得减，顺时针是startAngle + rentRate * 2 * Math.PI
			// ctx.stroke()

      this.ctx = ctx
      this.lineWidth = ringWidth
      this.centerX = centerX
      this.centerY = centerY
      this.radius = radius
      this.startAngle = startAngle
      this.endAngle = startAngle - this.rentRate * 2 * Math.PI
      this.progress = this.startAngle
      setTimeout(() => {
        this.animateProgress()
      }, 800)

			// 绘制中间文本
			const percentageNumber = this.rentRate * 100 > Number((this.rentRate * 100).toFixed(0)) ? (this.rentRate * 100).toFixed(2) : Number((this.rentRate * 100).toFixed(0))
			const percentageNumberText = String(percentageNumber)
			const percentageNumberWidth = ctx.measureText(percentageNumberText).width // dpr有缩放所以*2
			const percentageTagWidth = ctx.measureText('%').width // 百分号字号只有一半，dpr有缩放所以*2
			const totalWidth = percentageNumberWidth + percentageTagWidth
			ctx.font = `bold ${60}px sans-serif`
			ctx.fillStyle = '#333333'
			ctx.textAlign = 'left'
			ctx.textBaseline = 'middle'
			ctx.fillText(percentageNumberText, centerX - totalWidth + percentageTagWidth, centerY)
			ctx.font = `${30}px sans-serif`
			ctx.fillText('%', centerX + totalWidth - percentageTagWidth, centerY) // 因为是左对齐，所以要减去两个自身宽度,+2给点间距

			ctx.font = `${30}px sans-serif`
			ctx.fillStyle = '#6d6e6e'
			ctx.textAlign = 'center'
			ctx.fillText('出租率', centerX, centerY + 25)

			// === 绘制左边连线 + 文本 ===
			// const leftAngle = startAngle + rentRate * 2 * Math.PI
			const leftAngle = startAngle + (1 - this.rentRate) * 2 * Math.PI / 2
			const leftX = centerX + Math.cos(leftAngle) * (radius + ringWidth / 2)
			const leftY = centerY + Math.sin(leftAngle) * (radius + ringWidth / 2)
			const leftStartX = centerX - radius * 2 - ringWidth / 2
			const leftStartY = centerY / 2 + centerY / 4

			ctx.beginPath()
			ctx.moveTo(leftStartX, leftStartY)
			ctx.lineTo(centerX - radius - ringWidth, leftStartY)
			ctx.lineTo(leftX + ringWidth / 2, leftY + ringWidth / 2)
			ctx.strokeStyle = '#babdc0'
			ctx.lineWidth = 1
			ctx.stroke()

			ctx.fillStyle = '#6d6e6e'
			ctx.textAlign = 'left'
			ctx.font = `${26}px sans-serif`
			ctx.fillText('空置数量', leftStartX, leftStartY - 26 / 2 - 4) // 4是给点间距
			ctx.fillStyle = '#07d280'
			ctx.font = `bold ${44}px sans-serif`
			ctx.fillText(String(this.totalEmpty), leftStartX, leftStartY + 44 / 2 + 4) // 4是给点间距

			// 绘制右边连线 + 文本
			const rightAngle = startAngle - this.rentRate * 2 * Math.PI / 2 // 除以2是去进度条中间值
			const rightX = centerX + Math.cos(rightAngle) * (radius + ringWidth / 2)
			const rightY = centerY + Math.sin(rightAngle) * (radius + ringWidth / 2)
			const rightStartX = centerX + radius * 2 + ringWidth / 2
			const rightStartY = centerY / 2 + centerY / 4

			ctx.beginPath()
			ctx.moveTo(rightStartX, rightStartY)
			ctx.lineTo(centerX + radius + ringWidth, rightStartY)
			ctx.lineTo(rightX - ringWidth / 2, rightY - ringWidth / 2)
			ctx.strokeStyle = '#babdc0'
			ctx.stroke()

			ctx.fillStyle = '#6d6e6e'
			ctx.textAlign = 'right'
			ctx.font = `${26}px sans-serif`
			ctx.fillText('出租数量', rightStartX, rightStartY - 26 / 2 - 4) // 4是给点间距
			ctx.fillStyle = '#f15b5b'
			ctx.font = `bold ${44}px sans-serif`
			ctx.fillText(String(this.totalRent), rightStartX, rightStartY + 44 / 2 + 4) // 4是给点间距
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/product/testRing.vue